import { render, staticRenderFns } from "./client-details.vue?vue&type=template&id=6a003266"
import script from "./client-details.vue?vue&type=script&lang=ts"
export * from "./client-details.vue?vue&type=script&lang=ts"
import style0 from "./client-details.vue?vue&type=style&index=0&id=6a003266&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a003266')) {
      api.createRecord('6a003266', component.options)
    } else {
      api.reload('6a003266', component.options)
    }
    module.hot.accept("./client-details.vue?vue&type=template&id=6a003266", function () {
      api.rerender('6a003266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/client-details.vue"
export default component.exports